export const SalaryCertificatePaths = {
  MANAGE_REQUEST_SALARY_CERTIFICATE: 'salary-certificate',
  MANAGE_REQUEST_CREATE_SALARY_CERTIFICATE: 'create',
  MANAGE_REQUEST_EDIT_SALARY_CERTIFICATE: 'edit/:requestId',
};
